export class InviteService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.inviteUrl = this.apiService.getResourceUrl("/invite");
    this.inviteUrlResource = this.$resource(this.inviteUrl, null);
  }

  getInviteUrl() {
    const promise = this.inviteUrlResource.get().$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/invite/invite.service.js